import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

export const DRAGGABLE_CELL_CLASS = 'header-draggable-cell';
export const DRAGOVER_CLASS = 'header-dragover';
export const DRAGGABLE_CELL_ID = 'headerDraggableCell';

export const MIN_CELL_WIDTH = 120;
export const CELL_INDENT_WIDTH = 8;
export const SCROLL_INDICATOR_WIDTH = 40;

const useStyles = createUseStyles(({ colors, sizes }: Theme) => ({
  '@global': {
    [`.${DRAGGABLE_CELL_CLASS}`]: {
      outline: `3px dotted ${colors.borderControlHover}`,
    },
  },
  scrollContainer: {
    composes: ['col'],
    position: 'relative',
    padding: CELL_INDENT_WIDTH,
  },
  links: {
    width: '100%',
    height: '100%',
    display: 'inline-flex',
    gap: sizes.panelLinks.marginRight,
    alignItems: 'center',
    overflow: 'hidden',
    paddingInlineEnd: 10,
  },
  emptyDropCell: {
    height: 24,
    flex: 'auto',
  },
  scrollIndicator: {
    position: 'absolute',
    top: 0,
    opacity: 0,
    width: SCROLL_INDICATOR_WIDTH,
    height: sizes.mainHeader.height,
    display: 'flex',
    alignItems: 'center',
    fontSize: 18,
    color: colors.typoSecondary,
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    pointerEvents: 'none',
    transition: 'opacity 0.2s linear, color 0.15s linear',
    '&:hover': {
      color: colors.typoPrimary,
    },
    '&:nth-last-child(2)': {
      background: `linear-gradient(to right, ${colors.backgroundHeader} 60%, transparent)`,
      left: 0,
      justifyContent: 'flex-start',
      paddingLeft: 4,
    },
    '&:nth-last-child(1)': {
      background: `linear-gradient(to left, ${colors.backgroundHeader} 60%, transparent)`,
      right: 0,
      justifyContent: 'flex-end',
      paddingRight: 4,
    },
  },
  show: {
    opacity: 1,
    pointerEvents: 'auto',
  },
}));

export const useLinkStyles = createUseStyles(({ colors, sizes }: Theme) => ({
  link: {
    position: 'relative',
    minWidth: MIN_CELL_WIDTH,
    height: 32,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    padding: '0px 8px',
    boxSizing: 'border-box',
    background: colors.secondary,
    borderRadius: sizes.panelLinks.borderRadius,
    lineHeight: 1.1,
    cursor: 'pointer',
    '&  > div': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
      background: 'none',
      padding: 0,
      margin: 0,
    },
    '&:hover, &:focus-within': {
      background: colors.secondaryHover,
      color: colors.typoSecondary,
    },
    [`&.${DRAGOVER_CLASS}:before`]: {
      content: '""',
      display: 'block',
      position: 'absolute',
      left: -6,
      top: 0,
      height: '100%',
      width: 4,
      background: colors.primary,
    },
  },

  closeIcon: {
    cursor: 'pointer',
    fontSize: sizes.tabsTabButtonCloseIcon.fontSize,
    '&:hover': {
      opacity: 0.5,
    },
  },
}));

export default useStyles;
